import { ref } from 'vue';

export const ICONS_BASE =
  process.env.NODE_ENV === 'development'
    ? '/assets/images/icons'
    : '/local/templates/dist/assets/images/icons';

export function useEditingDrawer() {
  const open = ref(false);

  const showDrawer = () => {
    open.value = true;
  };

  const onClose = () => {
    open.value = false;
  };

  return {
    open,
    showDrawer,
    onClose,
  };
}
